import React,{Component} from 'react';
import AddHashTagMutation from '../../mutations/AddHashTagMutation';
import DeleteHashTagMutation from '../../mutations/DeleteHashTagMutation';
import EditHashTagMutation from '../../mutations/EditHashTagMutation';
import cookie from '../../helper/cookie'
import Relay from 'react-relay';

export default class Message extends Component {
  constructor (props){
    super (props);
    
    var hashTags = [];
    this.props.data.map((object, index) => {
      hashTags.push({
        id:index+1,
        tag : object.tag,
        messsage : object.message,
        isEdit:false,
        pid: object.pid
      });
    });

    this.state={
      table_content : hashTags,
      error:"",
    };
    this.onKeyPressed = this.onKeyPressed.bind(this);
    this.saveData=this.saveData.bind(this);
    this.removeRow=this.removeRow.bind(this);
    this.editData=this.editData.bind(this);
  }
  editData(i)
  {
    var tmpRows= this.state.table_content;
    tmpRows[i].isEdit=true;
    this.setState({table_content:tmpRows});
  }
  removeRow(i)
  {
    var tmpRows= this.state.table_content;
    Relay.Store.update(new DeleteHashTagMutation({
        tag: tmpRows[i].tag,
        message: tmpRows[i].messsage,
        agentId: cookie.get('userId'),
        pid: tmpRows[i].pid
      }), {
        onFailure: (t) => {
          console.log('onFailure of DeleteHashTagMutation', t);
        },
        onSuccess: (t) => {
          console.log('onSuccess of DeleteHashTagMutation', t);
        }
    });
    tmpRows.splice(i,1);
    this.setState({table_content:tmpRows});
  }
  onKeyPressed(){
    var addNew = this.state.table_content;
    addNew.splice(0,0,{
                        id:addNew.length+1,
                        tag:"",
                        messsage:"",
                        isEdit:true,
                        pid:""
                      });
    this.setState({table_content:addNew});
  }
  saveData(tag,msg,i){
    // var tagref="inputTag"+i;
    // var msgref="inputMessage"+i;
    // var tag=this.refs["inputTag"+i].value.trim();
    // var msg=this.refs["inputMessage"+i].value.trim();
    if(tag!=="" && msg!=="")
    {
      var frontFacers=this.state.table_content;
      if(tag.charAt(0)!='#')
      {
        tag="#"+tag;
      }
      var bool=false;
      for(var j=0;j<frontFacers.length;j++)
      {
          if(frontFacers[j].tag==tag && i!=j){
            bool=true;
            break;
          }
      }
      if(bool)
      {
        frontFacers[i].id=frontFacers[i].id;
        frontFacers[i].tag=tag;
        frontFacers[i].messsage=msg;
        frontFacers[i].isEdit=true;
        this.setState({table_content:frontFacers,error:"Please enter unique hashtag"});
      }
      else {
        frontFacers[i].id=frontFacers[i].id;
        frontFacers[i].tag=tag;
        frontFacers[i].messsage=msg;
        frontFacers[i].isEdit=false;
        //Relay Query to add hash tag
        if (frontFacers[i].pid == "") {
          Relay.Store.update(new AddHashTagMutation({
            tag: frontFacers[i].tag,
            message: frontFacers[i].messsage,
            agentId: cookie.get('userId')
          }), {
            onFailure: (t) => {
              console.log('onFailure of AddHashTag', t);
            },
            onSuccess: (t) => {
              console.log('onSuccess of AddHashTag', t);
            }
          });
        }
        else {
          Relay.Store.update(new EditHashTagMutation({
            tag: frontFacers[i].tag,
            message: frontFacers[i].messsage,
            agentId: cookie.get('userId'),
            pid: frontFacers[i].pid
          }), {
            onFailure: (t) => {
              console.log('onFailure of EditHashTag', t);
            },
            onSuccess: (t) => {
              console.log('onSuccess of EditHashTag', t);
            }
          });
        }
        this.setState({table_content:frontFacers,error:""});
      }
    }
    else {
      this.setState({error:"Please fill all fields"});
    }
  }

  render (){
    var st={
        vert: {
        verticalAlign:'bottom',
      },
      noborder:{
        border:'none',
      },
      background:{
        backgroundColor:"#fbfbfb",
      },

      noborderback:{
        border:'none',
        backgroundColor:"#fbfbfb",
      },

      scroll_div:{
        border:'none',
        overflow:"auto",
        height:368,

      },
      table:{
        tableLayout: 'fixed',
        wordWrap: 'break-word',
        borderRadius: '5px',
        backgroundColor: '#ffffff',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
      },
      btn:{
        border:'none',
        outline:'none',
      },
      btnHover:{
        cursor:'pointer',
      },
    };

    return(
      <div className="row">
      <ul className="list-group" style={st.noborderback}>
        <li className="list-group-item col-md-8" style={st.noborderback}>
          <p className="text-muted "><strong>SENDMESSAGES</strong></p>
        </li>

        <li className="list-group-item col-md-4" style={st.noborderback}>
          <p className="text-primary btn" onClick={this.onKeyPressed}><strong>ADDNEW</strong></p>
        </li>
      </ul>
      <table className="table table-hover table-responsive" style={st.noborder}>
        <thead >
          <tr style={st.background}>
            <th className=" col-md-2 text-muted text-center">Hash tag</th>
            <th className=" col-md-8 text-center text-muted">Message</th>
            <th className=" col-md-2"></th>
          </tr>
        </thead>
        </table>
        <p className="text-danger">
          {this.state.error}
        </p>
        <div style={st.scroll_div} id="style-1">
        <table className="table table-hover table-responsive" style={st.table}>
        <tbody >
          {this.state.table_content.map(function(con,i){
            return(
              <Row key={con.id} rowData={con} handleSave={this.saveData} rowref={i} handleEdit={this.editData} handleRemove={this.removeRow}/>
            );
            // if(con.isEdit)
            // {
            //   return(
            //     <tr>
            //       <td className=" col-md-2 text-muted"><input type="text" className="form-control" ref={"inputTag"+i} defaultValue={con.tag} placeholder="hashtag" /></td>
            //       <td className="text-center col-md-8 text-muted	"><input type="text" className="form-control" ref={"inputMessage"+i} defaultValue={con.messsage} placeholder="messsage" /></td>
            //       <td className=" col-md-2 text-muted"><a style={st.btn} onClick={this.saveData.bind(this,i)} className="glyphicon glyphicon-floppy-disk btn btn-link"></a></td>
            //     </tr>
            //   );
            // }
            // else {
            //   return(
            //     <tr  >
            //       <td className=" col-md-2 text-muted">{con.tag}</td>
            //       <td className="text-center col-md-8 text-muted">{con.messsage}</td>
            //       <td className=" col-md-2 text-muted">
            //       <a style={st.btn} onClick={this.editData.bind(this,i)} className="glyphicon glyphicon-pencil btn btn-link"></a>
            //       <a style={st.btnHover} className="pull-right text-muted" onClick={this.removeRow.bind(this,i)}>&times;</a>
            //       </td>
            //     </tr>
            //   );
            // }

          }.bind(this)
        )}
        </tbody>
      </table>
      </div>
      </div>
    );
  }
}
class Row extends Component {
  constructor(props) {
    super(props);
    this.editClicked=this.editClicked.bind(this);
    this.saveClicked=this.saveClicked.bind(this);
    this.removeClicked=this.removeClicked.bind(this);
  }
  editClicked()
  {
    this.props.handleEdit(this.props.rowref);
  }
  removeClicked()
  {
    this.props.handleRemove(this.props.rowref);
  }
  saveClicked()
  {
    this.props.handleSave(this.refs.inputTag.value.trim(), this.refs.inputMessage.value.trim(),this.props.rowref);
  }
  render()
  {
    var st={
      btn:{
        border:'none',
        outline:'none',
      },
      btnHover:{
        cursor:'pointer',
      },
    };
    if(this.props.rowData.isEdit) {
      return(
        <tr>
          <td className=" col-md-2 text-muted"><input type="text" className="form-control" ref="inputTag" defaultValue={this.props.rowData.tag} placeholder="hashtag" /></td>
          <td className="text-center col-md-8 text-muted	"><input type="text" className="form-control" ref="inputMessage" defaultValue={this.props.rowData.messsage} placeholder="message" /></td>
          <td className=" col-md-2 text-muted"><a style={st.btn} onClick={this.saveClicked} className="glyphicon glyphicon-floppy-disk btn btn-link"></a></td>
        </tr>
      );
    }
    else {
      return(
        <tr  >
          <td className=" col-md-2 text-muted">{this.props.rowData.tag}</td>
          <td className="text-center col-md-8 text-muted	">{this.props.rowData.messsage}</td>
          <td className=" col-md-2 text-muted">
          <a style={st.btn} onClick={this.editClicked} className="glyphicon glyphicon-pencil btn btn-link"></a>
          <a style={st.btnHover} className="pull-right  text-muted" onClick={this.removeClicked}>&times;</a>
          </td>
        </tr>
      );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/AgentSettings/message.js
 **/